import React, { useContext } from "react";
import { ProductTabs } from "../../../../components";
import Context from "../../../../context/conventionTrackerContext";
import { IMAGES } from "../../../../utils/constants";
import "./index.scss";

/**
 * @desc Display a background for products.
 */
export const Background = ({ children }) => {
  // CONSTANTS ----------------------------------------------------------------

  const { brand, convention } = useContext(Context);

  // DYNAMIC CONSTANTS --------------------------------------------------------

  const { backgroundStyle, backgroundImage, header } = convention;

  const getLogoURI = () => {
    return IMAGES.LOGO[brand] || "";
  };

  const getBackgroundProps = () => {
    const style = Object.assign({}, backgroundStyle);
    const backgroundProps = {
      className: "flex background",
      style,
    };

    if (backgroundImage) {
      backgroundProps.style["backgroundImage"] = `url(${backgroundImage})`;
    }
    return backgroundProps;
  };

  // COMPONENT ----------------------------------------------------------------

  const renderHeader = () => {
    if (header) {
      return <h1>{header}</h1>;
    }
  };

  const productContainerProps = {
    className: "product-container row",
  };

  return (
    <div {...getBackgroundProps()}>
      <div className={"flex header"}>
        <div className={"line"} />
        <img
          className={"brand-logo"}
          src={getLogoURI()}
          alt={`${brand} Logo`}
        />
        <div className={"line"} />
      </div>
      {renderHeader()}
      <ProductTabs />
      <div {...productContainerProps}>{children}</div>
    </div>
  );
};
